/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { Link } from 'gatsby'
import clsx from 'clsx'
import { removeFoldersFromUrl } from '@/helpers/removeFoldersFromUrl'
import { withTrailingSlash } from '@/helpers/withTrailingSlash'

const setRelAttribute = (rel: string | undefined, new_tab: boolean) => {
  let value = ''
  if (rel) {
    value = rel
  }

  if (new_tab) {
    value += ' noopener noreferrer'
  }

  return value || undefined
}

export function CustomLink({
  is_external,
  new_tab,
  link_url,
  rel,
  children,
  className,
  activeClassName,
  custom_id,
  'aria-label': ariaLabel,
  customCssClass
}: CustomLinkTypes & React.HTMLAttributes<HTMLAnchorElement>) {
  const extHref = link_url?.url
  const intHref = removeFoldersFromUrl(link_url?.cached_url)

  return is_external || extHref ? (
    <a
      href={extHref}
      target={new_tab ? '_blank' : undefined}
      rel={setRelAttribute(rel, new_tab)}
      className={clsx(className, customCssClass)}
      aria-label={ariaLabel}
      id={custom_id}
    >
      {children}
    </a>
  ) : (
    <Link
      to={withTrailingSlash(intHref)}
      className={clsx(className, customCssClass)}
      activeClassName={activeClassName}
      aria-label={ariaLabel}
      id={custom_id}
    >
      {children}
    </Link>
  )
}
